<script lang="ts" setup>
import { onMounted, onUnmounted, ref } from 'vue';

const props = defineProps({
  numOfCircles: {
    type: Number,
    default: 8
  },
  distanceFromCenter: {
    type: Number,
    default: 45
  },
  activeChangeTimeout: {
    type: Number,
    default: 500
  }
});
const activeIndex = ref(0);

const circles = Array.from({ length: props.numOfCircles }, (_, i) => {
  const angle = (i / props.numOfCircles) * 360;
  return {
    transform: `rotate(${angle}deg) translate(${props.distanceFromCenter}px) rotate(-${angle}deg)`
  };
});

let interval;
onMounted(() => {
  interval = setInterval(() => {
    activeIndex.value = (activeIndex.value + 1) % props.numOfCircles;
  }, props.activeChangeTimeout);
});

onUnmounted(() => {
  clearInterval(interval);
});
</script>

<template>
  <div class="relative flex h-36 w-36 items-center justify-center">
    <div
      v-for="(style, index) in circles"
      :key="index"
      class="absolute h-5 w-5 rounded-full transition-colors duration-700"
      :class="index === activeIndex ? 'bg-black' : 'bg-gray-300'"
      :style="style"
    ></div>
  </div>
</template>
